import { chatProviders, emailProviders, smsProviders, pushProviders, inAppProviders } from './channels';
export const providers = [
    ...emailProviders,
    ...smsProviders,
    ...chatProviders,
    ...pushProviders,
    ...inAppProviders,
];
